import { render, staticRenderFns } from "./ResolutionList.vue?vue&type=template&id=509fb833&scoped=true"
import script from "./ResolutionList.vue?vue&type=script&lang=js"
export * from "./ResolutionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fb833",
  null
  
)

export default component.exports